import React, { useState } from 'react'
import { DropdownKeys } from '@/modules/results/components/Filters'
import { PriceInputs } from './PriceInputs'
import Dropdown from '@wiggui/ds/Dropdown'
import { Transition } from '@wiggui/ds/Transition'
import { Skeleton } from '@wiggui/ds/Skeleton'

interface IPriceProps {
  setPrices: (o: any) => void
  prices: any
  isOpen: boolean
  isLoading?: boolean
  setIsOpen: ({
    isOpen,
    dropdownKey
  }: {
    isOpen: boolean
    dropdownKey: DropdownKeys
  }) => void
  onInputPricesChange: ({ key, value }: { key: string; value: number }) => void
  pricesToShowCopy: string
}

const initialFormState = {
  priceFrom: {
    name: 'priceFrom',
    value: 0,
    paramName: 'priceFrom'
  },
  priceTo: {
    name: 'priceTo',
    value: 0,
    paramName: 'priceTo'
  }
} as const

export const PriceSelect = ({
  setPrices,
  setIsOpen,
  onInputPricesChange,
  prices,
  isOpen,
  pricesToShowCopy,
  isLoading
}: IPriceProps) => {
  const [formState, setFormState] = useState(initialFormState)
  const onClose = () => {
    setIsOpen({ isOpen: false, dropdownKey: 'isOpenPrice' })
  }
  const onSetIsOpen = (isOpen: boolean) => {
    setIsOpen({ isOpen, dropdownKey: 'isOpenPrice' })
  }

  const onSuccessPrices = () => {
    const verifiedLocalMinPrice =
      formState?.priceFrom?.value === 0
        ? undefined
        : formState?.priceFrom?.value

    const verifiedLocalMaxPrice =
      formState?.priceTo?.value === 0 ? undefined : formState?.priceTo?.value

    setPrices({
      priceTo: verifiedLocalMaxPrice,
      priceFrom: verifiedLocalMinPrice
    })
    onClose()
  }

  return (
    <Dropdown isOpen={isOpen} setIsOpen={onSetIsOpen} onClose={onClose}>
      <Dropdown.Trigger
        className={`flex flex-col justify-center gap-1 w-[208px] rounded-full cursor-pointer ${
          isOpen
            ? 'bg-white shadow-[0px_3px_6px_0px_rgba(34,34,34,0.16)]'
            : 'hover:bg-surface-strokes '
        }`}
      >
        <div className="flex flex-col justify-between rounded-full py-[6px] px-4">
          <p className="text-left text-secondary text-xs">Precio</p>
          {isLoading ? (
            <Skeleton height="h-6" width="w-[176px]" />
          ) : (
            <p className="text-base text-primary max-w-[200px] truncate">
              {pricesToShowCopy}
            </p>
          )}
        </div>
      </Dropdown.Trigger>
      <Dropdown.Menu
        buttomSheetClassName="py-3 px-4 flex flex-col items-center justify-center w-full gap-4"
        className="w-full min-w-[350px] px-4 items-center justify-center"
      >
        <Transition
          className="!flex flex-col gap-4 w-full h-full"
          show={isOpen}
        >
          <PriceInputs
            prices={prices}
            onInputPricesChange={onInputPricesChange}
          />
        </Transition>
      </Dropdown.Menu>
    </Dropdown>
  )
}
